import { Grid } from "@mui/material";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import { PatientVital } from "../../../../../../../../services";
import {
  HEIGHT_SITTING_OPTS,
  HEIGHT_UNIT_OPTS,
  VitalFormik,
} from "../vital-constant";

interface HeightFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const HeightFields = ({ formik, ind }: HeightFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  const selectHandleChange = (k: keyof PatientVital, v: string | null) => {
    formik.setFieldValue(getKey(k), v);
  };

  return (
    <Grid container gap={2}>
      <Grid xs={2.6}>
        <CustomSelect
          name={getKey("unit")}
          placeholder="CM"
          options={HEIGHT_UNIT_OPTS}
          value={activeVital?.unit}
          onChange={(v) => selectHandleChange("unit", v)}
        />
      </Grid>
      <Grid xs={1.8}>
        <Input
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: "e.g. 170 (cm)",
          }}
        />
      </Grid>
      <Grid xs={2.6}>
        <CustomSelect
          name={getKey("type")}
          placeholder="Sitting"
          options={HEIGHT_SITTING_OPTS}
          value={activeVital?.type}
          onChange={(v) => selectHandleChange("type", v)}
        />
      </Grid>
    </Grid>
  );
};

export default HeightFields;
